import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

interface DialogHeaderProps {
    onClose: () => void;
    title: string;
    variant: TypographyProps['variant'];
    noBgColor?: boolean;
}

const DialogHeader = ({ onClose, title, variant, noBgColor }: DialogHeaderProps) => {
    const paperVariant = noBgColor ? 'dialogHeaderNoBg' : 'dialogHeader';

    return (
        <Paper variant={paperVariant} elevation={0} square>
            <Typography variant={variant} className="DialogHeader-title">
                {title}
            </Typography>
            <IconButton onClick={onClose} aria-label="close" size="small" className="DialogHeader-closeButton">
                <CloseIcon />
            </IconButton>
        </Paper>
    );
};

export default DialogHeader;
